import { useState } from "react"
import { useIntl } from "react-intl"

import { Button, Dialog, ICONS, StaffBodyTextS, StaffHeading3, TextArea, TextInput } from "@doktor-se/bones-ui"

import styles from "./ReportBugDialog.module.scss"

interface FlagProps {
  isOpen: boolean
  onClose: () => void
  flag: (flagBody: string, flagSubject: string) => void
}

type formInput = {
  text: string
  error: boolean
}

const defaultFormInput = {
  text: "",
  error: false
}

const ReportBugDialog = ({ isOpen, onClose, flag }: FlagProps) => {
  const intl = useIntl()
  const [flagSubject, setFlagSubject] = useState<formInput>(defaultFormInput)
  const [flagBody, setFlagBody] = useState<formInput>(defaultFormInput)

  const handleFlagSubjectChange = (text: string) => setFlagSubject({ text: text, error: false })

  const handleFlagBodyChange = (text: string) => setFlagBody({ text: text, error: false })

  const clearFlagBody = () => setFlagBody(defaultFormInput)

  const handleSubmit = () => {
    if (!flagSubject.text) {
      setFlagSubject(prev => ({ ...prev, error: true }))
      return
    }
    if (!flagBody.text) {
      setFlagBody(prev => ({ ...prev, error: true }))
      return
    }

    flag(flagBody.text.trim(), flagSubject.text.trim())
    setFlagBody(defaultFormInput)
    setFlagSubject(defaultFormInput)
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} closeAriaLabel={intl.formatMessage({ id: "modal.close" })} fixedWidth>
      <div className={styles.contentWrapper}>
        <div className={styles.formHeader}>
          <ICONS.Flag />
          <StaffHeading3 style={{ margin: "8px 0" }}>{intl.formatMessage({ id: "flag.report.title" })}</StaffHeading3>
          <StaffBodyTextS>{intl.formatMessage({ id: "flag.subject.subheading" })}</StaffBodyTextS>
        </div>

        <TextInput
          variant="onSurface"
          label={intl.formatMessage({ id: "flag.subject.label" })}
          value={flagSubject.text}
          caption={intl.formatMessage({ id: "flag.subject.placeholder" })}
          onChange={handleFlagSubjectChange}
          errorMessage={flagSubject.error ? intl.formatMessage({ id: "flag.subject.error" }) : undefined}
        />

        <div className={styles.flagBodyWrapper}>
          <TextArea
            variant="onSurface"
            label={intl.formatMessage({ id: "flag.body.label" })}
            value={flagBody.text}
            caption={intl.formatMessage({ id: "flag.body.placeholder" })}
            onChange={handleFlagBodyChange}
            errorMessage={flagBody.error ? intl.formatMessage({ id: "flag.body.error" }) : undefined}
            noBorder
            expandable
          />
          {flagBody.text && (
            <button onClick={clearFlagBody}>
              <ICONS.Close width={14} />
            </button>
          )}
        </div>

        <Button color="primary" variant="primary" fullWidth onPress={handleSubmit}>
          {intl.formatMessage({ id: "flag.send.report" })}
        </Button>
      </div>
    </Dialog>
  )
}

export default ReportBugDialog
